import { useQuery } from '@tanstack/react-query';
import { API, graphqlOperation } from 'aws-amplify';

const listKPIsQuery = `
  query ListKPIRules($orgID: ID!, $nextToken: String) {
    listKPIRules(
      filter: { orgID: { eq: $orgID }, isDeleted: { eq: false } }
      limit: 10000
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        title
        order
        action
        sourceType
        triggerID
        formula
        dimensions
        isHidden
        abbreviation
      }
    }
  }
`;

const fetchKPIs = async (orgID: string) => {
  const kpis: any[] = [];
  let nextToken: string | null = null;

  do {
    const res: any = await API.graphql(
      graphqlOperation(listKPIsQuery, { orgID, nextToken })
    );
    kpis.push(...res.data.listKPIRules.items);
    nextToken = res.data.listKPIRules.nextToken;
  } while (nextToken);

  // Add name alias and sort by sourceType
  kpis.forEach((el) => (el.name = el.title));
  kpis.sort((a, b) =>
    (a.sourceType || '')
      .toLowerCase()
      .localeCompare((b.sourceType || '').toLowerCase())
  );

  return kpis;
};

export default function useListKPIs() {
  const orgID = (global as any).me?.orgID;
  console.log('ORGID@!! ', orgID);

  const { data, isLoading, error } = useQuery({
    queryKey: ['listKPIs', orgID],
    queryFn: () => fetchKPIs(orgID),
    enabled: !!orgID,
    staleTime: 60 * 60 * 1000, // 1 hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours
    refetchOnWindowFocus: false,
  });
  console.log('DATATAATATA ', data);
  console.log('ERRRORR ', error);

  return { data: data ?? [], isLoading, error };
}
